import "core-js/modules/es6.regexp.match";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
import { stringify } from 'qs';
import keys from 'lodash/keys';
import * as types from './types';
import fetchSearch from '~/services/search';
export default {
  fetchContent: function () {
    var _fetchContent = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee(_ref, _ref2) {
      var commit, keyword, query, _ref3, productSearch, details, total, products, redirectUrl, currentQuery;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              commit = _ref.commit;
              keyword = _ref2.keyword, query = _ref2.query;

              if (keyword) {
                _context.next = 6;
                break;
              }

              commit(types.SET_DESCRIPTION, {
                query: ''
              });
              commit(types.SET_PRODUCTS, {
                products: [],
                total: 0
              });
              return _context.abrupt("return");

            case 6:
              _context.next = 8;
              return fetchSearch(this, keyword, query);

            case 8:
              _ref3 = _context.sent;
              productSearch = _ref3.productSearch;

              if (productSearch) {
                _context.next = 14;
                break;
              }

              commit(types.SET_DESCRIPTION, {
                query: keyword
              });
              commit(types.SET_PRODUCTS, {
                products: [],
                total: 0
              });
              return _context.abrupt("return");

            case 14:
              details = productSearch.details, total = productSearch.total, products = productSearch.products;

              if (!details.redirect) {
                _context.next = 20;
                break;
              }

              redirectUrl = "".concat(details.redirect_to);
              currentQuery = keys(query).length ? "&".concat(stringify(query)) : '';

              if (redirectUrl.match(/^\/[A-Z]{2}\/[a-z]{2}\/(?:c|e|p|q|s)\//)) {
                this.app.context.redirect(301, "".concat(redirectUrl).concat(currentQuery));
              } else {
                window.location.href = "".concat(redirectUrl).concat(currentQuery);
              }

              return _context.abrupt("return");

            case 20:
              commit(types.SET_DESCRIPTION, details);
              commit(types.SET_PRODUCTS, {
                products: products,
                total: total
              });

            case 22:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function fetchContent(_x, _x2) {
      return _fetchContent.apply(this, arguments);
    }

    return fetchContent;
  }(),
  appendProducts: function () {
    var _appendProducts = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee2(_ref4, _ref5) {
      var commit, keyword, query, _ref6, products;

      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              commit = _ref4.commit;
              keyword = _ref5.keyword, query = _ref5.query;
              _context2.next = 4;
              return fetchSearch(this, keyword, query);

            case 4:
              _ref6 = _context2.sent;
              products = _ref6.productSearch.products;
              commit(types.APPEND_PRODUCTS, products);

            case 7:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, this);
    }));

    function appendProducts(_x3, _x4) {
      return _appendProducts.apply(this, arguments);
    }

    return appendProducts;
  }(),
  prependProducts: function () {
    var _prependProducts = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee3(_ref7, _ref8) {
      var commit, keyword, query, _ref9, products;

      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              commit = _ref7.commit;
              keyword = _ref8.keyword, query = _ref8.query;
              _context3.next = 4;
              return fetchSearch(this, keyword, query);

            case 4:
              _ref9 = _context3.sent;
              products = _ref9.productSearch.products;
              commit(types.PREPEND_PRODUCTS, products);

            case 7:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, this);
    }));

    function prependProducts(_x5, _x6) {
      return _prependProducts.apply(this, arguments);
    }

    return prependProducts;
  }()
};